import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useApp();
  const navigate = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", city: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(form);
      toast.success("Account created!");
      navigate(loc.state?.from || "/dashboard", { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  const field = (key, props) => (
    <input
      data-testid={`register-${key}`}
      className="w-full rounded-xl bg-asf-app border border-slate-200 px-4 py-3 outline-none focus:border-asf-orange"
      value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} {...props} />
  );

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-center mb-8"><Logo /></div>
      <div className="asf-card p-8">
        <h1 className="font-display text-2xl font-bold mb-1">Create your account</h1>
        <p className="text-sm text-slate-500 mb-6">Start learning in minutes.</p>
        <form onSubmit={submit} className="space-y-4">
          {field("name", { placeholder: "Full name", required: true })}
          {field("email", { placeholder: "Email", type: "email", required: true })}
          {field("password", { placeholder: "Password (min 6 chars)", type: "password", required: true, minLength: 6 })}
          {field("phone", { placeholder: "Mobile number" })}
          {field("city", { placeholder: "City" })}
          <button data-testid="register-submit" disabled={loading} className="btn-primary w-full py-3.5">
            {loading ? "Creating…" : "Create Account"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">or</span><div className="flex-1 h-px bg-slate-200" />
        </div>
        <button data-testid="google-register" onClick={() => { const r = window.location.origin + "/auth/callback"; window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(r)}`; }}
          className="btn-secondary w-full py-3.5 flex items-center justify-center gap-2">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4" /> Continue with Google
        </button>
        <p className="text-sm text-slate-500 mt-5 text-center">
          Already have an account? <Link to="/login" className="text-asf-orange font-semibold">Log in</Link>
        </p>
      </div>
    </div>
  );
}
